// Curated lucide-react icon resolver, kept small to avoid bloating the bundle.
// Strapi content uses iconKey strings; this maps to a real React component.
import {
  ShieldCheck, Search, FileText, Building2, FileSpreadsheet, Sparkles, Briefcase,
  Users, Calendar, Settings, Globe, Lock, Layers, Workflow, BarChart3, Mail,
  TrendingUp, BookOpen, HelpCircle, Cpu, Database, Zap, CheckCircle2,
  PlayCircle, ArrowUpRight, AlertCircle,
} from "lucide-react";

const MAP = {
  ShieldCheck, Search, FileText, Building2, FileSpreadsheet, Sparkles, Briefcase,
  Users, Calendar, Settings, Globe, Lock, Layers, Workflow, BarChart3, Mail,
  TrendingUp, BookOpen, HelpCircle, Cpu, Database, Zap, CheckCircle2,
  PlayCircle, ArrowUpRight, AlertCircle,
};

export default function Icon({ name, fallback = "Sparkles", ...rest }) {
  const Comp = MAP[name] || MAP[fallback] || Sparkles;
  return <Comp {...rest} />;
}

export const ICON_KEYS = Object.keys(MAP);
